import React from 'react';
import {Button, useRefresh} from 'react-admin';
import {connect} from "react-redux";
import {payrollRecreateNotesAction} from "../../actions/payrollActions";

const RecreateNotesButton = props => {
     const refresh = useRefresh();
     const {onRecreateNotes, record, redirect, id, loading} = props
     
    return (
        <Button 
            label="Recreate PayrollNotes In Employee" 
            onClick={()=>{
                onRecreateNotes(record.id || id, record, redirect);
                refresh();
            }} 
            disabled={loading || record.status !== "Approved"} 
        />
    );
};

 export default connect(
    state => ({loading: state.admin.loading}), 
    dispatch => ({
        onRecreateNotes: (id, payrollRun, path) => dispatch(payrollRecreateNotesAction(id, payrollRun, path))
    })
)(RecreateNotesButton)